import Utils from 'general/utils/Utils';
import axiosClient from './axiosClient';

const agencyCommissionApi = {
    // tao commission
    createAgencyCommission: (params) => {
        const url = '/agency/commission/create';
        return axiosClient.post(url, params);
    },

    // cap nhat commission
    updateAgencyCommission: (commissionId, params) => {
        const url = `/agency/commission/${commissionId}`;
        return axiosClient.put(url, params);
    },

    // xoa commission
    deleteAgencyCommission: (commissionId) => {
        const url = `/agency/commission/${commissionId}`;
        return axiosClient.delete(url);
    },

    // lay lich su giao dich
    getAgencyCommissionTransactions: (params) => {
        const url = `/agency/commission/transactions`;
        return axiosClient.get(url, { params: Utils.filterParams(params) });
    },

    // lay bao cao giao dich
    getAgencyCommissionReport: (params) => {
        const url = `/agency/commission/report`;
        return axiosClient.get(url, { params });
    },
};

export default agencyCommissionApi;
